import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/einstellungen/benachrichtigungen')({
  head: () => noIndexRouteHead('settingsNotifications', 'de'),
  component: () => <SettingsPage section="benachrichtigungen" />,
})
